import { PhoneCall } from "lucide-react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { useGetCachedCurrentLoanApplication } from "@krea/customer-features/store/current-loan-application/hooks";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

import { AdvisorImage } from "../advisor-cta-banner/advisor-image";

interface IYourAdvisorProps {
  title: ReactNode;
  isOnModal?: boolean;
  className?: string;
}

export const YourAdvisor = ({
  title,
  isOnModal = false,
  className,
}: IYourAdvisorProps) => {
  const { data } = useGetCachedCurrentLoanApplication();
  const { t } = useTranslation();
  const { assignedToAdminUser } = data ?? {};

  return (
    <div
      className={twMerge(
        "tw-py-4 tw-px-5 tw-bg-mint-100 tw-flex max-sm:tw-items-center",
        className,
      )}
    >
      <AdvisorImage className="tw-mr-4" />

      <div className="tw-flex tw-w-full tw-justify-between tw-gap-3 max-sm:tw-flex-col">
        <div>
          {title}

          <p
            className={twMerge("tw-m-0 tw-text-base tw-text-black-300", {
              "tw-text-black": isOnModal,
            })}
          >
            <span className={twMerge(isOnModal && "tw-font-semibold")}>
              {t("advice.manual.yourAdvisor")}:
            </span>{" "}
            <span className={twMerge(!isOnModal && "tw-font-semibold")}>
              {assignedToAdminUser?.firstName} {assignedToAdminUser?.lastName}
            </span>
          </p>
        </div>

        {assignedToAdminUser?.mobilePhoneNumber && !isOnModal && (
          <a
            className="tw-flex tw-items-center tw-gap-2 tw-font-semibold !tw-text-primary"
            href={`tel:${assignedToAdminUser.mobilePhoneNumber}`}
          >
            <PhoneCall size={17} />
            <span>{assignedToAdminUser.mobilePhoneNumber}</span>
          </a>
        )}
      </div>
    </div>
  );
};
